export default __webpack_public_path__ + "static/media/floorrock-acoustic-cp5-rockwool-komposition_comp.69818fc3.jpg";